import { useEffect } from 'react';
import { useEntityList } from '@backstage/plugin-catalog-react';
import {
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';

interface CustomFilters {
  kind?: any;
  regionFilter?: EntityRegionFilter;
}

// EntityRegionFilter for filtering by spec.region
export class EntityRegionFilter implements EntityFilter {
  readonly values: string[];

  constructor(values: string[]) {
    this.values = values;
  }

  getCatalogFilters(): Record<string, string | string[]> {
    return { 'spec.region': this.values };
  }

  filterEntity(entity: Entity): boolean {
    const entityRegion = entity.spec?.region as string | undefined;
    return entityRegion !== undefined && this.values.includes(entityRegion);
  }

  toQueryValue(): string[] {
    return this.values;
  }
}

export const ProjectRegionPicker = () => {
  const {
    filters: { kind, regionFilter },
    updateFilters,
  } = useEntityList<CustomFilters>();

  const currentKind = String(kind?.value ?? '').toLowerCase();
  const isProject = currentKind === 'project';

  useEffect(() => {
    if (!isProject && regionFilter) {
      updateFilters({ regionFilter: undefined });
    }
  }, [isProject, regionFilter, updateFilters]);

  if (!isProject) {
    return null;
  }

  return (
    <EntityAutocompletePicker
      label="Region"
      name={'region' as any}
      path="spec.region"
      Filter={EntityRegionFilter}
      showCounts
    />
  );
};
